
export { ActionTextType } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-grandiaziende-deploy-prod/libs/shared/models/src/lib/optionalText.models.ts"